import { render, staticRenderFns } from "./platRegisterUser.vue?vue&type=template&id=09dfac0b&"
import script from "./platRegisterUser.vue?vue&type=script&lang=js&"
export * from "./platRegisterUser.vue?vue&type=script&lang=js&"
import style0 from "./platRegisterUser.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./platRegisterUser.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports